<template>
  <div>
    <h2 class="title">Clients</h2>
    <v-client-table
      :data="table_clients.items"
      :columns="table_clients.columns"
      :options="table_clients.options"
      class="table-default"
      :class="{ 'table-default--loading': table_clients_preloader }"
    >
      <template #h__select>
        <label
          v-if="table_clients.items.length && table_clients.items.some(item => item.arrival === null)"
          class="checkbox checkbox--table"
        >
          <input
            v-model="is_checked_clients"
            type="checkbox"
            name="checked_all"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #h__full_name><div class="table-default__left">Full name</div></template>
      <template #h__group><div class="table-default__left">Group</div></template>
      <template #h__hotel><div class="table-default__left">Hotel</div></template>
      <template #select="{ row }">
        <label v-if="!row.arrival" class="checkbox  checkbox--table">
          <input
            v-model="checked_clients"
            type="checkbox"
            :value="row.id"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
            <span
              :class="`fflag ff-md fflag-${row.client.citizenship ? row.client.citizenship.code : 'empty'}`"
              v-tooltip="{ content: row.client.citizenship ? row.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
            ></span>
          <template v-if="row.client.gender">
            <img v-if="row.client.gender.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
            <img v-if="row.client.gender.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          </template>
          <img v-else src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.full_name }}
          </router-link>
          <span v-if="row.age">({{ row.age }} y.o.)</span>
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.client.manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.client.manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <template v-if="row.client.group">
            <router-link
              :to="{ name: 'clients-groups-general', params: { id: row.client.group.id } }"
              class="table-default__link-border"
            >
              {{ row.client.group.name }}
            </router-link>
          </template>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
      <template #hotel="{ row }">
        <div class="table-default__left">
          <template v-if="row.after">
            <template>{{ row.after.hotel_name }} ({{ row.after.room_name }})</template>
            <div v-if="row.after.hotel_management_room_short_name">
              Room: {{ row.after.hotel_management_room_short_name }}
            </div>
          </template>
          <template v-else>-</template>
        </div>
      </template>
      <template #safari="{ row }">
        <template v-if="row.client.safari.length">
          <template v-if="row.client.safari.length > 1">
              <span class="status-tag" style="background-color: #e85c20">
                {{ row.client.safari.length }}
              </span>
          </template>
          <template v-else>
            <div class="table-default__controls">
              <span class="table-default__activity table-default__activity--active table-default__activity--safari"></span>
              <div>
                {{ row.client.safari[0].short_itinerary }}<br>
                {{ formatDate(row.client.safari[0].tour_start) }}
              </div>
            </div>
          </template>
        </template>
        <template v-else>-</template>
      </template>
      <template #departure="{ row }">
        <template v-if="row.client.transport.departure.departure_method">
          <div class="table-default__controls" style="margin-bottom: 10px;">
              <span
                class="table-default__transport table-default__transport--arrival"
                :class="{
                'table-default__transport--present': row.client.transport.departure.departure_method,
                'table-default__transport--confirmed': row.client.transport.departure.departure_confirmed,
                'table-default__transport--car': row.client.transport.departure.departure_method?.code === 'car',
                'table-default__transport--bus': row.client.transport.departure.departure_method?.code === 'bus',
                'table-default__transport--self': row.client.transport.departure.departure_method?.code === 'self'
              }"
              ></span>
            <div>
              {{ row.client.transport.departure.departure_date ? formatDate(row.client.transport.departure.departure_date) : '-' }}
              {{ row.client.transport.departure.departure_time ? row.client.transport.departure.departure_time : '' }}
            </div>
            <div>
              {{ row.client.transport.departure.departure_location ? row.client.transport.departure.departure_location.short_name : '-' }}
            </div>
          </div>
          <br>
          <div v-if="row.client.transfers.departure.length" class="table-default__controls">
            <img src="@/assets/img/departure-modal-icon.svg" alt="Transfers">
            <div>
              {{ formatDate(row.client.transfers.departure[0].pick_up_date) }} {{ row.client.transfers.departure[0].pick_up_time }}
            </div>
          </div>
          <span v-else class="status-tag" style="background-color: #e85c20">
              No transfer
            </span>
        </template>
        <template v-else>-</template>
      </template>
      <template #notes="{ row }">
        <app-input
          v-if="is_general_manager || is_operations_supervisor"
          @change.native="onPatchArrivalClient(row.id, { arrival_notes: row.arrival_notes })"
          v-model="row.arrival_notes"
          class="input--min-200"
        />
        <template v-else>{{ row.arrival_notes || '-' }}</template>
      </template>
    </v-client-table>
    <template v-if="table_in_process.items.length">
      <app-cells><h2 class="title">Rentals</h2></app-cells>
      <v-client-table
        :data="table_in_process.items"
        :columns="table_in_process.columns"
        :options="table_in_process.options"
        class="table-default"
        :class="{ 'table-default--loading': table_in_process_preloader }"
      >
        <template #h__id><div class="table-default__left">ID</div></template>
        <template #h__client><div class="table-default__left">Client</div></template>
        <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.status.color }">
            {{ row.status.name }}
          </span>
        </template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'rentals-detail', params: {id: row.id }}" class="table-default__link-border">
              Rental - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #client="{ row }">
          <div class="table-default__left">
            <router-link v-if="row.client" :to="{name: 'clients-detail', params: {id: row.client.client.id }}" class="table-default__link-border">
              {{ row.client.client.full_name }}
            </router-link>
            <template v-else>-</template>
          </div>
        </template>
        <template #amount="{ row }">
          <span
            v-if="row.discount_amount && row.discount_amount > 0"
            class="status-tag"
            :style="{ 'backgroundColor': '#77b017' }"
            v-tooltip="{ content: `Discount: ${row.discount_amount}$<br>${row.discount_description || ''}`, placement: 'left', offset: 10, html: true }"
          >
            {{ row.amount }}$
          </span>
          <span
            v-else
            v-tooltip="{ content: amountTooltipContent(row), placement: 'left', offset: 10, html: true }"
          >
            {{ row.amount }}$
          </span>
        </template>
        <template #balance="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': row.balance === 0 ? '#77b017' : row.balance > 0 ? '#f0c427' :'#e85c20' }"
          >
            {{ row.balance === 0 ? 'Paid': `${row.balance}$` }}
          </span>
        </template>
        <template #returned="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': row.rental_items === row.rental_items_returned ? '#77b017' : '#e85c20' }"
          >
            {{ row.rental_items }} / {{ row.rental_items_returned }}
          </span>
        </template>
        <template #rental_start="{ row }">
          {{ dateFormat(row.rental_start) }}
        </template>
        <template #rental_end="{ row }">
          <span
            v-tooltip="{ content: 'Rental end expired', placement: 'top-start', offset: 10 }"
            v-if="row.end_expired"
            class="status-tag"
            :style="{ 'backgroundColor': '#e85c20' }"
          >
            {{ dateFormat(row.rental_end) }}
          </span>
          <span v-else>{{ dateFormat(row.rental_end) }}</span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationProcess"
            v-if="pagination_in_process.pages > 1"
            v-model="pagination_in_process.page"
            :page-count="pagination_in_process.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_in_process.count" :count="table_in_process.items.length" :page="pagination_in_process.page" />
      </app-cells>
    </template>
    <template v-if="table_arrival.items.length">
      <app-cells><h2 class="title">Arrivals</h2></app-cells>
      <v-client-table
        :data="table_arrival.items"
        :columns="table_arrival.columns"
        :options="table_arrival.options"
        class="table-default"
        style="max-width: 1000px;"
      >
        <template #h__date>
          <div class="table-default__left">Date & Location</div>
        </template>
        <template #date="{ row }">
          <router-link
            :to="{ name: 'climbing-arrivals-detail', params: { id: row.id } }"
            class="table-default__link-border"
          >
            {{ formatDate(row.date) }} at {{ row.location.name }}
          </router-link>
        </template>
        <template #managers="{ row }">
          <div class="table-default__controls">
            <div v-for="manager of row.managers" :key="manager.id" class="table-default__photo">
              <img
                :src="getUserAvatar(manager.crop.crop_url)" alt="Avatar"
                v-tooltip="{ content: manager.full_name, placement: 'top-start', offset: 10 }"
              >
            </div>
          </div>
        </template>
        <template #clients="{ row }">{{ row.pax }}</template>
      </v-client-table>
    </template>
    <modal
      name="create-arrival-popup"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('create-arrival-popup')" class="popup__close" type="button"></button>
        <div class="popup__title">Creating new arrival</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckArrivalForm">
            <app-form-group label="Date" required>
              <app-date-picker
                v-model="form_arrival.date"
                placeholder="Date"
                :error="$v.form_arrival.date.$error"
              />
              <template #error>
                <div v-if="$v.form_arrival.date.$dirty && !$v.form_arrival.date.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Location" required>
              <app-select
                @input="onLocationSelected"
                @search="onLocationSearch"
                v-model="form_arrival.location"
                :options="location_options"
                :clearable="false"
                placeholder="Location"
                :error="$v.form_arrival.location.$error"
              />
              <template #error>
                <div v-if="$v.form_arrival.location.$dirty && !$v.form_arrival.location.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Managers" required>
              <app-select
                v-model="form_arrival.managers"
                :options="manager_options"
                label="first_name"
                placeholder="Managers"
                multiple
                :error="$v.form_arrival.managers.$error"
              >
                <template #open-indicator>
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                    <path d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z" fill="#606060"/>
                  </svg>
                </template>
                <template #option="option">
                  <div class="select__item d-center">{{ option.first_name }} {{ option.last_name }}</div>
                </template>
                <template #selected-option="option">
                  <div class="selected d-center">{{ option.first_name }} {{ option.last_name }}</div>
                </template>
              </app-select>
              <template #error>
                <div v-if="$v.form_arrival.managers.$dirty && !$v.form_arrival.managers.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form_arrival.$error" type="submit" ref="submit_arrival">Create arrival</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected clients: <span>{{ checked_clients.length }}</span></div>
      <app-button @click.native="onShowArrivalModal">Create arrival</app-button>
    </div>
  </div>
</template>

<script>
import { format, parse, parseISO } from 'date-fns'
import { required } from 'vuelidate/lib/validators'
import {
  getClimbingArrivals,
  getClimbingGroupsClientsArrivals,
  getGoogleSearch,
  getRentals,
  getUsers,
  patchClimbingGroupClients,
  postClimbingArrivals,
  postLocation,
} from '@/http'
import debounce from 'lodash/debounce'

export default {
  name: 'ClimbingGroupsDetailArrivals',
  props: {
    groupDetail: Object
  },
  data() {
    return {
      is_loaded: false,
      table_clients_preloader: false,
      table_clients: {
        items: [],
        columns: ['full_name', 'hotel', 'notes', 'safari', 'departure', 'group'],
        options: {
          headings: {
            select: '',
            full_name: 'Full name',
            group: 'Group',
            hotel: 'Hotel',
            safari: 'Safari',
            departure: 'Departure',
            notes: 'Notes',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_arrival: {
        items: [],
        columns: ['date', 'managers', 'clients'],
        options: {
          headings: {
            date: 'Date & Location',
            managers: 'Managers',
            clients: 'Clients'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_in_process: {
        items: [],
        columns: ['status', 'id', 'client', 'amount', 'balance', 'returned', 'rental_start', 'rental_end'],
        options: {
          headings: {
            'status': 'Status',
            'id': 'ID',
            'client': 'Client',
            'amount': 'Amount',
            'balance': 'Balance',
            'returned': 'Returned',
            'rental_start': 'Start',
            'rental_end': 'End',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_in_process: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_in_process_preloader: false,
      is_checked_clients: false,
      checked_clients: [],
      is_show_flying_block: false,
      form_arrival: {},
      location_options: [],
      manager_options: [],
    }
  },
  validations: {
    form_arrival: {
      date: { required },
      location: { required },
      managers: { required },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_operations_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    },
  },
  watch: {
    is_checked_clients(value) {
      if (value) {
        this.table_clients.items.forEach(item => {
          if (!this.checked_clients.includes(item.id) && !item.arrival) this.checked_clients.push(item.id)
        })
      } else {
        this.checked_clients = []
      }
    },
    checked_clients(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_clients.length) this.is_checked_clients = false
    },
  },
  created() {
    this.fetchClientsItems()
    this.fetchArrivalsItems()
    getUsers({ group: 'operations_manager,operations_supervisor', is_active: true })
      .then(response => { this.manager_options = response.data })
    if (this.is_general_manager || this.is_operations_supervisor) this.table_clients.columns.unshift('select')
    this.fetchItemsProcess()
  },
  methods: {
    fetchItemsProcess() {
      const params = {
        page: this.pagination_in_process.page,
        page_size: 20,
        climbing_group: this.$route.params.id
      }
      getRentals(params)
        .then(res => {
          this.table_in_process.items = res.data.results
          this.pagination_in_process.pages = res.data.pages
          this.pagination_in_process.count = res.data.count
          this.is_loaded = true
          this.table_in_process_preloader = false
        })
    },
    onClickPaginationProcess(page) {
      this.table_in_process_preloader = true
      this.pagination_in_process.page = page
      this.fetchItemsProcess()
    },
    onPatchArrivalClient(id, data) {
      patchClimbingGroupClients(this.$route.params.id, id, data)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
        })
    },
    onCheckArrivalForm() {
      this.$v.form_arrival.$touch()
      if (this.$v.form_arrival.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendArrivalForm()
      }
    },
    sendArrivalForm() {
      this.$refs.submit_arrival.preload = true
      postClimbingArrivals(this.normalizeForm())
        .finally(() => { this.$refs.submit_arrival.preload = false })
        .then(() => {
          this.fetchClientsItems()
          this.fetchArrivalsItems()
          this.$modal.hide('create-arrival-popup')
          this.$notify({
            type: 'success',
            title: 'Arrival created successfully',
          })
        })
    },
    normalizeForm() {
      const form = { ...this.form_arrival }

      form.clients = this.checked_clients
      form.location = form.location.id
      form.managers = form.managers.map(item => item.id)
      form.climbing_group = +this.$route.params.id
      return form
    },
    onShowArrivalModal() {
      this.form_arrival = { date: this.groupDetail.tour_end }
      this.$v.form_arrival.$reset()
      this.$modal.show('create-arrival-popup')
    },
    fetchClientsItems() {
      this.table_clients_preloader = true
      getClimbingGroupsClientsArrivals(this.$route.params.id)
        .then(res => {
          this.table_clients.items = res.data
          this.table_clients_preloader = false
          this.checked_clients = []
        })
    },
    fetchArrivalsItems() {
      getClimbingArrivals({ climbing_group: this.$route.params.id })
        .then(response => { this.table_arrival.items = response.data })
    },
    onLocationSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.form_arrival.location = res.data
      })
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          vm.location_options = response.data
          loading(false)
        })
      }
    }, 350),
    formatDate(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMM yyyy')
    },
    formatDateTime(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMM yyyy HH:mm')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    amountTooltipContent(data) {
      let content = `Rental: ${data.amount_rental}$<br>Purchase: ${data.amount_sale}$`
      if (data.resupply_fee) content += '<br>Resupply: 50$'
      if (data.discount_method) content += `<br>Discount: ${data.discount_method.code === 'basic' ? `${data.discount}$` : `${data.discount}%`}`
      return content
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
  }
}
</script>
